import AvaliationPublic from '../components/AvaliationPublic'

let routes = {
    path: '/public',
    component: resolve => require(['../components/layout/Login'], resolve),
    children: [
        {
            path: '/public/:hash?',
            name: 'Avaliation',
            component: AvaliationPublic
        }
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/public.js